<template>
    <div class="cart-payment">
        <span class="cart-payment-span">TOTAL</span>
        <span class="cart-payment-value">{{ p_total }}</span>
    </div>
</template>

<script>
export default {
    name: 'name',
    props:{
        p_total: { type: String, default: () => '$0'}
    },
    methods: {}
}
</script>


// WEBPACK FOOTER //
// src/components/Total.vue